import { Injectable } from '@angular/core';
import {
    Router, Resolve,
    RouterStateSnapshot,
    ActivatedRouteSnapshot
} from '@angular/router';
import { Observable, of } from 'rxjs';
import { DocumentPublishingService } from '../services/document-publishing.service';

@Injectable({
    providedIn: 'root'
})
export class DocumentPublishingSettingsResolver implements Resolve<any> {
    constructor(private documentPublishService: DocumentPublishingService) { }

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<any> {
        let id = route.parent.params['id'];

        return this.documentPublishService.getDocumentPublishingSettingsForSite(id).then(response => {
            return response;
        });
    }
}
